import React from 'react';
import PropTypes from 'prop-types';
import { datasetColors } from '../../../enum';

function Tooltip(props) {
  const { tooltipModel, canvasRef } = props;
  if (!tooltipModel || !canvasRef.current) return null;
  const position = canvasRef.current.getBoundingClientRect();

  const renderDataPoint = (dataPoint) => {
    const count = dataPoint.dataset.counts[dataPoint.dataIndex];

    return (
      <div key={dataPoint.datasetIndex}>
        <div className="engage-results-matrix-tooltip__data-point">
          <div
            className="engage-results-matrix-tooltip__data-point-color"
            style={{
              backgroundColor: datasetColors[dataPoint.datasetIndex % datasetColors.length],
            }}
          />
          <div className="engage-results-matrix-tooltip__data-point-value">
            <div className="engage-results-matrix-tooltip__data-point-label">
              {dataPoint.dataset.label}
            </div>
            <div>
              {count} ({dataPoint.formattedValue}%)
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      className="engage-results-matrix-tooltip tooltip-wrapper"
      style={{
        opacity: tooltipModel.opacity,
        left: `${position.left + window.scrollX + tooltipModel.caretX}px`,
        top: `${position.top + window.scrollY + tooltipModel.caretY}px`,
      }}
    >
      <div className="engage-results-matrix-tooltip__title">{tooltipModel.title.join(', ')}</div>
      <div className="engage-results-matrix-tooltip__body">
        {tooltipModel.dataPoints.map(renderDataPoint)}
      </div>
    </div>
  );
}

Tooltip.propTypes = {
  tooltipModel: PropTypes.shape({
    opacity: PropTypes.number,
    caretX: PropTypes.number,
    caretY: PropTypes.number,
    title: PropTypes.arrayOf(PropTypes.string),
    dataPoints: PropTypes.arrayOf(
      PropTypes.shape({
        datasetIndex: PropTypes.number,
        dataIndex: PropTypes.number,
        formattedValue: PropTypes.string,
        dataset: PropTypes.shape({
          label: PropTypes.string,
          image: PropTypes.string,
          counts: PropTypes.arrayOf(PropTypes.number),
        }),
      })
    ),
  }),
  canvasRef: PropTypes.shape({
    current: PropTypes.shape({
      getBoundingClientRect: PropTypes.func,
    }),
  }),
};

Tooltip.defaultProps = {
  tooltipModel: undefined,
  canvasRef: undefined,
};

export default Tooltip;
